import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'lifedi-research-choice',
  templateUrl: './research-choice.component.html',
  styleUrls: ['./research-choice.component.scss']
})
export class ResearchChoiceComponent implements OnInit {

  @Input() consentForm: FormGroup;
  @Input() consentDetail;

  questionForm;
  choice;
  checkchoice = [];

  constructor(
    private fb: FormBuilder,
  ) { }

  get answers(): FormArray {
    if (this.consentForm) {
      return this.consentForm.controls['DATA'] as FormArray;
    }
  }

  ngOnInit(): void {
    // console.log(this.consentDetail);
    this.questionForm = this.fb.group({
      answer: ['']
    });

    this.answers.push(this.questionForm);

  }

  patchVal(e) {
    if (e.checked) {
      this.checkchoice.push(e.source.value);
    } else {
      const index = this.checkchoice.indexOf(e.source.value);
      if (index > -1) {
        this.checkchoice.splice(index, 1);
      }
    }

    this.questionForm.patchValue({
      answer: this.checkchoice
    });
    this.questionForm.get('answer').updateValueAndValidity();

    // console.log(this.checkchoice);
    // console.log(this.questionForm.value);
  }

}
